import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, of, switchMap, take } from 'rxjs';
import { getCustomerAccessToken } from 'src/app/shop';
import { VatNumberValidationResult } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class VatNumberService {
  constructor(
    private http: HttpClient,
    @Optional()
    @Inject(BASE_URL)
    private BASE_URL: string,
    private store: Store
  ) {}

  validateVatNumber(vatNumber: string) {
    if (!vatNumber) {
      return of({ valid: true });
    }
    return this.store.select(getCustomerAccessToken).pipe(
      first(),
      switchMap(token => {
        return this.http.get<VatNumberValidationResult>(
          `${this.BASE_URL}api/customer/vat/validate?token=${token?.accessToken}&vatNumber=${vatNumber}`
        );
      })
    );
  }
}
